var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":"ساخت ویژگی جدید محصول"}}),_c('crud-generator',{attrs:{"fields":_vm.fields,"name":"Specifications"},on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }